export const dataDefault = [{
    name: '现金流量期初余额',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 0
}, {
    name: '现金增加',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 1,
}, {
    name: '现金减少',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 2
}, {
    name: '现金流量期末余额',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 3
}, {
    name: '应收账款周转天数',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 4
}, {
    name: '存货周转天数',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 5
}, {
    name: '客房利润率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 6
}, {
    name: '餐饮利润率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 7
}, {
    name: '经营毛利率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 8
}, {
    name: '销售收入增长率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 9
}, {
    name: '经营毛利润增长率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 10
}];

export const columnsData = [
    {
        title: "项目",
        key: "name",
        type: "text"
    }, {
        title: "Jan",
        key: "Jan",
        type: "percent"
    }, {
        title: "Feb",
        key: "Feb",
        type: "percent"
    }, {
        title: "Mar",
        key: "Mar",
        type: "percent"
    }, {
        title: "Apr",
        key: "Apr",
        type: "percent"
    }, {
        title: "May",
        key: "May",
        type: "percent"
    }, {
        title: "Jun",
        key: "Jun",
        type: "percent"
    }, {
        title: "Jul",
        key: "Jul",
        type: "percent"
    }, {
        title: "Aug",
        key: "Aug",
        type: "percent"
    }, {
        title: "Sep",
        key: "Sep",
        type: "percent"
    }, {
        title: "Oct",
        key: "Oct",
        type: "percent"
    }, {
        title: "Nov",
        key: "Nov",
        type: "percent"
    }, {
        title: "Dec",
        key: "Dec",
        type: "percent"
    }
];

export const costData = [{
    name: '食品成本率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 0
}, {
    name: '人力成本率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 1
}, {
    name: '能源成本率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 2
}, {
    name: '其他费用及成本率',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 3
}]

export const depositData = [{
    name: '银行存款期初余额',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 0
}, {
    name: '银行存款增加',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 1
}, {
    name: '银行存款减少',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 2
}, {
    name: '银行存款期末余额',
    Jan: '0',
    Feb: '0',
    Mar: '0',
    Apr: '0',
    May: '0',
    Jun: '0',
    Jul: '0',
    Aug: '0',
    Sep: '0',
    Oct: '0',
    Nov: '0',
    Dec: '0',
    sort: 3
}]
export default dataDefault;


// WEBPACK FOOTER //
// ./src/components/table/monthlyAnalysis/data.js